import { StakingPlan } from 'src/models';
import { AppError, EipError } from 'src/redux/types';
export const formatTimestamp = timestamp => {
  return {
    days: Math.floor(timestamp / 1000 / 60 / 60 / 24),
    hours: Math.floor(timestamp / 1000 / 60 / 60) % 24,
    minutes: Math.floor(timestamp / 1000 / 60) % 60,
    seconds: Math.floor(timestamp / 1000) % 60
  };
};
export const calcPercentageRemaining = (currentTimestamp, beginTimestamp, endTimestamp, rate) => {
  const diffMsUsed = currentTimestamp - beginTimestamp;

  if (diffMsUsed <= 0) {
    return rate * 100;
  }

  if (currentTimestamp >= endTimestamp) {
    return 100;
  }

  const diffMs = endTimestamp - beginTimestamp;
  return (rate - (rate - 1) / diffMs * diffMsUsed) * 100;
};
export const isStakingStarted = featureToggle => {
  try {
    if (featureToggle === '') {
      return false;
    }

    const {
      startTime,
      endTime
    } = JSON.parse(featureToggle);

    if (isNaN(startTime) || isNaN(endTime)) {
      return false;
    }

    const timestamp = Math.floor(Date.now() / 1000);
    return startTime <= timestamp && timestamp <= endTime;
  } catch {
    return false;
  }
}; // eslint-disable-next-line complexity

export const formatErrorMessage = (error, stakePlan, endDate) => {
  switch (error) {
    case EipError.USER_REJECTED_REQUEST:
      return 'Transaction has been canceled';

    case EipError.INVALID_SIGNATURE:
      return 'The signature is invalid';

    case EipError.NOT_NFT_OWNER:
      return 'The NFT item is invalid';

    case EipError.CANNOT_STAKE_ZERO:
      return 'Unable to stake with 0 THG';

    case EipError.EXPIRED_SIGNATURE:
      return 'The signature is expired';

    case EipError.STAKING_ID_EXISTS:
      return 'The staking id already existed';

    case EipError.NOT_SUFFICIENT_TOKEN:
      return 'Insufficient tokens';

    case EipError.NOT_APPROVED_SPEND_AMOUNT:
      return 'Staking contract is not approved to spend payment amount';

    case EipError.STAKING_ID_NOT_EXISTS:
      return 'The staking id not existed';

    case EipError.NOT_STAKING_OWNER:
      return 'You are not owner of the staking';

    case EipError.STAKING_ID_UNSTUCK:
      return 'This staking is no longer available for claim';

    case EipError.NOT_TIME_UNLOCK:
      return 'Your stake is under locking time';

    case AppError.MAINTENANCE_STAKING:
      return 'This feature is under maintenance, please try again in a few minutes';

    case AppError.INVALID_STAKING_PLAN:
      return 'The staking plan is invalid, please try again';

    case AppError.INVALID_STAKING_AMOUNT:
      return 'The staking amount is invalid, please try again';

    case AppError.OUT_OF_TIME_STAKING:
      return stakePlan && endDate ? formatErrorOutOfTimeStaking(stakePlan, endDate) : 'Can not stake this time, please try again';

    case AppError.STAKING_POOL_FULLED:
      return 'Please try again later once the pool is available';

    case AppError.HERO_UNAVAILABLE:
      return 'Your selected heroes is unavailable';

    case AppError.NOT_READY_TO_UNSTAKE:
      return 'Your stake is not ready to unstake';

    case AppError.ALREADY_UNSTAKE:
      return 'You are previous unstake';

    case AppError.COUNTDOWN_CLAIM_REWARD:
      return 'You only claim reward each every 24 hours';

    case AppError.MAX_PENDING_STAKE:
      return 'Please wait for your stake to be processed. It would take a few minutes';

    case AppError.EMPTY_STAKING_REWARD:
      return 'There is no reward for this stake to claim';

    case AppError.NOT_READY_FOR_CLAIM:
      return 'This stake is not ready for claim yet. Please come back later';

    default:
      return 'Something went wrong, please try again';
  }
};

const formatErrorOutOfTimeStaking = (stakePlan, endDate) => {
  const plan = stakePlan === StakingPlan.FLEXIBLE ? 'Flexible' : stakePlan === StakingPlan.SIX_MONTHS ? '6-month' : '12-month';
  const date = new Date(endDate).toUTCString();
  return `Cannot stake with the ${plan} Plan because THG Staking will be expired on ${date}. Please try another Plan.`;
};